import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { putCotizacion } from '../../api/quoteApi';

export const updateQuote = createAsyncThunk(
  'quote/updateQuote',
  async (_, { getState, rejectWithValue }) => {

    const { driver, contractor, coverage} = getState();

    let conductor;
    if (contractor.formValues.esConductorHabitual == "Si") {
      conductor = 1;
    } else {
      conductor = 0;
    }

    let direccion;
    if (contractor.formValues.esMismoDomicilioFiscal == "Si") {
      direccion = 1;
    } else {
      direccion = 0;
    }

    const payload = {
      mismo_contratante_conductor: conductor,
      conductor: {
        nombre: driver.formValues.nombres,
        primer_apellido: driver.formValues.primerApellido,
        segundo_apellido: driver.formValues.segundoApellido,
        fecha_nacimiento: driver.formValues.fechaNacimiento,
        sexo: driver.formValues.genero
      },
      contratante: {
        nombre: contractor.formValues.nombres,
        primer_apellido: contractor.formValues.primerApellido,
        segundo_apellido: contractor.formValues.segundoApellido,
        fecha_nacimiento: contractor.formValues.fechaNacimiento,
        rfc: contractor.formValues.rfc,
        sexo: contractor.formValues.genero,
        regimen_fiscal: contractor.formValues.regimenFiscal,
        email: contractor.formValues.correoElectronico,
        telefono: contractor.formValues.telefonoMovil
      },
      domicilio: {
        calle: contractor.formValues.calle,
        num_exterior: contractor.formValues.numeroExterior,
        num_interior: contractor.formValues.numeroInterior,
        estado: contractor.formValues.estadoRepublica,
        municipio: contractor.formValues.alcaldiaMunicipio,
        id_asenta_cpcons: contractor.formValues.colonia,
        codigo_postal: contractor.formValues.codigoPostal
      },
      mismo_domicilio_fiscal: direccion,
      domicilio_fiscal: {
        calle: contractor.formValues.fiscalCalle,
        num_exterior: contractor.formValues.fiscalNumeroExterior,
        num_interior: contractor.formValues.fiscalNumeroInterior,
        estado: contractor.formValues.fiscalEstadoRepublica,
        municipio: contractor.formValues.fiscalAlcaldiaMunicipio,
        id_asenta_cpcons: contractor.formValues.fiscalColonia,
        codigo_postal: contractor.formValues.fiscalCodigoPostal
      }
    };
    
    const uuid = coverage.uuid;

    try {
      await new Promise(resolve => setTimeout(resolve, 2000));

      const data = await putCotizacion({payload, uuid});

      if (data.success) {
        return data;
      } else {
        return rejectWithValue(data.message || 'Error al seleccionar el paquete');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const initialState = {
  step: 1,
  maxStepReached: 1,

  loading: false,

  error: null,

  quoteDataInitial: {
    vehicleData: {
      tipo: '',
      modelo: '',
      marca: '',
      subMarca: '',
      descripcion: ''
    },
    driverData: {
      genero: '',
      fechaNacimiento: '',
      codigoPostal: ''
    },
    contractorData: {
      rfc: '',
      correoElectronico: '',
      telefonoMovil: ''
    }
  },

  termsAndConditions: {
      privacyNotice: false,
      termsAndConditions: false
  },
  
  isFormValid: false,

  updateQuoteStatus: 'idle'
};

const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {

    nextStep: (state) => {
      if (state.step < 4) {
        state.step += 1;
        if (state.step > state.maxStepReached) {
          state.maxStepReached = state.step;
        }
      }
    },
    
    prevStep: (state) => {
      if (state.step > 1) {
        state.step -= 1;
      }
    },
    
    setStep: (state, action) => {
      const targetStep = action.payload;

      if (targetStep <= state.maxStepReached && targetStep >= 1) {
        state.step = targetStep;
      }
    },
    
    updateQuoteDataInitial: (state, action) => {
      state.quoteDataInitial = { ...state.quoteDataInitial, ...action.payload };
    },

    setTermAcceptance: (state, action) => {
      const { term, accepted } = action.payload;
      state.termsAndConditions[term] = accepted;
      
      const allAccepted = Object.values(state.termsAndConditions).every(Boolean);
      state.allTermsAccepted = allAccepted;
    },

    setFormValidity: (state, action) => {
      state.isFormValid = action.payload;
    },
    
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    resetUpdateQuoteStatus: (state) => {
      state.updateQuoteStatus = 'idle';
      state.error = null;
    },
    
    setError: (state, action) => {
      state.error = action.payload;
    },
    
    resetQuote: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateQuote.pending, (state) => {
        state.updateQuoteStatus = 'loading';
        state.error = null;
      })
      .addCase(updateQuote.fulfilled, (state) => {
        state.updateQuoteStatus = 'succeeded';
        state.error = null;
      })
      .addCase(updateQuote.rejected, (state, action) => {
        state.updateQuoteStatus = 'failed';
        state.error = action.payload || "Error al actualizar la cotización";
      });
  }
});

export const {
  nextStep,
  prevStep,
  setStep,
  updateQuoteDataInitial,
  setTermAcceptance,
  setFormValidity,
  setLoading,
  resetUpdateQuoteStatus,
  setError,
  resetQuote
} = quoteSlice.actions;

export default quoteSlice.reducer;